import { SITE } from '@/lib/site-config';

export function personSchema(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: SITE.founder.name,
    jobTitle: SITE.founder.title,
    worksFor: {
      '@type': 'Organization',
      name: SITE.brand,
      url: SITE.url,
    },
    description:
      `Principal Consultant в ${SITE.brand}. 10 лет в IT-индустрии + переход в AI-инжиниринг. Закрываю один процесс end-to-end за 1-2 месяца.`,
    url: SITE.url,
    knowsAbout: [
      'AI',
      'RAG',
      'Computer Vision',
      'Bitrix24',
      'CRM-автоматизация',
      'AgroTech',
    ],
  };
}

export function organizationSchema(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: SITE.brand,
    url: SITE.url,
    description: SITE.description,
    founder: {
      '@type': 'Person',
      name: SITE.founder.name,
      jobTitle: SITE.founder.title,
    },
    areaServed: 'RU',
    priceRange: 'от 50 000 ₽',
    serviceType: [
      'AI-автоматизация',
      'RAG-разработка',
      'Computer Vision',
      'Bitrix24 интеграция',
      'Аналитика звонков',
    ],
  };
}

export function serviceCatalogSchema(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'OfferCatalog',
    name: `Пакеты ${SITE.brand}`,
    itemListElement: [
      {
        '@type': 'Offer',
        name: 'Разведка',
        description: 'Аудит процесса + roadmap. 1-2 недели.',
        priceSpecification: {
          '@type': 'PriceSpecification',
          minPrice: 50000,
          priceCurrency: 'RUB',
        },
      },
      {
        '@type': 'Offer',
        name: 'Пилот',
        description: 'Один процесс end-to-end в проде. 1-2 месяца.',
        priceSpecification: {
          '@type': 'PriceSpecification',
          minPrice: 150000,
          priceCurrency: 'RUB',
        },
      },
      {
        '@type': 'Offer',
        name: 'Трансформация',
        description: 'Автоматизация направления. 3-6 месяцев.',
        priceSpecification: {
          '@type': 'PriceSpecification',
          minPrice: 400000,
          priceCurrency: 'RUB',
        },
      },
    ],
  };
}

export type FAQ = { question: string; answer: string };

export function faqPageSchema(faqs: FAQ[]): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.answer,
      },
    })),
  };
}

export function articleSchema(input: {
  title: string;
  description: string;
  slug: string;
  datePublished: string;
  industryLabel: string;
}): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: input.title,
    description: input.description,
    url: `${SITE.url}/cases/${input.slug}`,
    datePublished: input.datePublished,
    dateModified: input.datePublished,
    author: {
      '@type': 'Person',
      name: SITE.founder.name,
      jobTitle: SITE.founder.title,
    },
    publisher: {
      '@type': 'Organization',
      name: SITE.brand,
      url: SITE.url,
    },
    about: input.industryLabel,
    image: `${SITE.url}/cases/${input.slug}/opengraph-image`,
  };
}

// Escape `<` to mitigate XSS via injected `</script>` in JSON-LD.
export function jsonLdScript(data: object): string {
  return JSON.stringify(data).replace(/</g, '\\u003c');
}
